import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@dynatrace/strato-components/buttons';

import { NotificationSettingsContext } from '../contexts/NotificationSettingsContext.js';
import { notificationMessages } from '../messages.js';

/**
 *
 * @internal
 */
export function NotificationToggleButton() {
  const {
    enabled,
    loading,
    toggleNotifications,
    hasReadPermission,
    hasNotFoundError,
  } = useContext(NotificationSettingsContext);

  return (
    <Button
      variant={enabled ? 'emphasized' : 'accent'}
      color={enabled ? 'neutral' : 'primary'}
      onClick={toggleNotifications}
      disabled={!hasReadPermission || hasNotFoundError}
      loading={loading}
    >
      <FormattedMessage
        {...notificationMessages.notificationsToggle}
        values={{ notificationEnabled: enabled }}
      />
    </Button>
  );
}
